import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { useStyles } from "./MobileDrawer.css";

class Info extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.infoStyle}>
        <div>{this.props.type}</div>
        <Avatar style={{ width: 50, height: 50 }}>
          <div style={{ fontSize: 35, color: "black", fontWeight: "bold" }}>
            {this.props.firstChar}
          </div>
        </Avatar>
        <div>{this.props.email}</div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Info);
